import { useQuery } from 'react-query'

import { QUERY_KEYS } from '../../api'
import { ApiParams } from '../../types'
import SuppliersViewApi from './api'

interface UseSuppliersViewProps extends ApiParams {}

const useSuppliersView = ({ filters }: UseSuppliersViewProps) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEYS.SUPPLIERS_ADMIN, filters],
    () => SuppliersViewApi.getSuppliersByFilters({ filters }),
    {
      staleTime: Infinity,
    },
  )

  return {
    suppliers: data,
    isLoading,
  }
}

export default useSuppliersView
